import { send } from '../../../../../../src/network';

export type PostBundleRatingsPostBody = {
  customer_id: number;
  bundle: number;
  liked: boolean | null;
  feedback?: string | null;
  pairing?: number | null;
};

export type PostBundleRatingsResponse = {
  bundle: number;
  liked: boolean | null;
  feedback: string | null;
  pairing: number | null;
};

export async function postBundleRatings(params: PostBundleRatingsPostBody) {
  const { customer_id: customerId, ...rest } = params;
  return send<PostBundleRatingsResponse>({
    method: 'POST',
    body: rest,
    path: `/api/v2/customers/${customerId}/bundle_ratings/`,
  });
}
